<template lang="html">
  <div class="diak-adatok-component">
    <h2 class="text-center">Tanulói adatok</h2>
    <v-container>
      <v-form
        ref="diak_adat_form"
        v-model="studDetailsVaild"
        lazy-validation
        v-show="studentdetails"
      >
      <br>
      <div class="subtitle-1"><b>Személyes adatok</b></div>
      <v-divider></v-divider><br>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-select
            :items="title_options"
            :value="title"
            @change="title = $event"
            label="Titulus választása"
            outlined
            append-icon="school"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="last_name"
            @change="last_name = $event"
            label="Vezetéknév"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="first_name"
            @change="first_name = $event"
            label="Keresztnév"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="middle_name"
            @change="middle_name = $event"
            label="Utónév"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="full_name"
            label="Teljes név"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="gender"
            @change="gender = $event"
            :items="gender_items"
            label="Neme"
            outlined
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="education"
            @change="education = $event"
            :items="education_items"
            label="Iskolai végzettség"
            outlined
            :rules="[rules.required]"
          >
          <template v-slot:item="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.text }}
            <br><br>
          </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            color="primary"
            @click="copyBirthName"
            outlined
            rounded
          >
          Név másolása
          </v-btn>
      </v-col>
      </v-row>

      <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_last_name"
          @change="birth_last_name = $event"
          label="Születési vezetéknév"
          :rules="[rules.required]"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_first_name"
          @change="birth_first_name = $event"
          label="Születési keresztnév"
          :rules="[rules.required]"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="birth_middle_name"
          @change="birth_middle_name = $event"
          label="Születési utónév"
          outlined

        ></v-text-field>
      </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            v-model="country_of_birth"
            label="Születési ország"
            append-icon="public"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="3">
          <v-text-field
            :value="place_of_birth"
            @change="place_of_birth = $event"
            label="Születési hely"
            :rules="[rules.required]"
            append-icon="room"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="3">
          <v-text-field
            :value="birthdate"
            @change="birthdate = $event"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            label="Születési idő"
            :rules="birthdateRules"
            append-icon="date_range"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="3">
          <v-select
            :value="nationality"
            @change="nationality = $event"
            :items="nationality_list"
            item-text="label"
            item-value="label"
            label="Nemzetiség"
            append-icon="language"
            :rules="[rules.required]"
            outlined

          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_last_name"
            @change="mother_last_name = $event"
            label="Anyja vezetéknév"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_first_name"
            @change="mother_first_name = $event"
            label="Anyja keresztnév"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="mother_middle_name"
            @change="mother_middle_name = $event"
            label="Anyja utónév"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            :value="identity_card_number"
            @change="identity_card_number = $event"
            label="Személyi igazolvány száma"
            :rules="[rules.required]"
            append-icon="credit_card"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :value="okirat_type"
            @change="okirat_type = $event"
            :items="okirat_types"
            item-value="code"
            item-text="type"
            label="Okmány típusa"
            outlined
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="address_card_number"
            @change="address_card_number = $event"
            label="Lakcímkártya száma"
            hint="Csak GKI képzés esetén kötelező"
            persistent-hint
            outlined
          ></v-text-field>
        </v-col>
        </v-row>
        <!--
        <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="tax_code"
            label="Adóazonosító jel"
            outlined
            v-mask="'##########'"
            hint="formátum: 0123456789"
            :rules="taxcodeRules"
            :disabled="no_tax"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox
          v-model="no_tax"
          label="Adószám letiltása"
          ></v-checkbox>
        </v-col>
      </v-row>
      -->
      <div class="subtitle-1"><b>Kapcsolati adatok</b></div>
      <v-divider></v-divider><br>

      <v-row>
        <v-col class="d-flex" cols="12" sm="12" md="6">
          <v-text-field
            :value="email1"
            @change="email1 = $event"
            label="E-mail"
            :rules="[rules.email]"
            append-icon="email"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" md="6">
          <v-text-field
            :value="phone1"
            @change="phone1 = $event"
            label="Telefonszám"
            append-icon="phone"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="!check18">
        <v-col class="d-flex" cols="12" md="6">
          <v-text-field
            :value="parent_email"
            @change="parent_email = $event"
            label="Szülői e-mail cím"
            append-icon="email"
            prepend-inner-icon="escalator_warning"
            outlined
            :rules="[rules.email, rules.parent_required]"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" md="6">
          <v-text-field
            :value="parent_phone"
            @change="parent_phone = $event"
            label="Szülői telefonszám"
            append-icon="phone"
            prepend-inner-icon="escalator_warning"
            outlined
            hint="formátum: 367012345678"
            persistent-hint
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>

        <div class="subtitle-1"><b>Állandó lakcím</b></div>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-select
            :value="per_country"
            @change="per_country = $event"
            :items="country_list"
            item-text="country"
            item-value="country"
            label="Ország"
            :rules="[rules.required]"
            outlined

          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_zip"
            @change="per_zip = $event, getPerCityName($event)"
            v-mask="'####'"
            label="Irányítószám"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            v-model="per_city"
            :rules="[rules.required]"
            label="Város"
            outlined
            :loading = "per_city_load"

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_public_premises"
            @change="per_public_premises = $event"
            label="Közterület"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-autocomplete
            :value="per_type_of_public_premises"
            @change="per_type_of_public_premises = $event"
            :items="publicpermises"
            item-text="label"
            item-value="label"
            label="Közterület típusa"
            :rules="[rules.required]"
            outlined

          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="per_house_number"
            @change="per_house_number = $event"
            label="Házszám"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_building_number"
            @change="per_building_number = $event"
            label="Épület"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_stairway_number"
            @change="per_stairway_number = $event"
            label="Lépcsőház"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_floor_number"
            @change="per_floor_number = $event"
            label="Emelet"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="per_door_number"
            @change="per_door_number = $event"
            label="Ajtó"
            outlined

          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn
            color="primary"
            @click="copyAddress"
            rounded
            outlined
          >
          Lakcím másolása
          </v-btn>
      </v-col>
      </v-row>

      <div class="subtitle-1"><b>Értesítési lakcím</b></div>
    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-select
          :value="temp_country"
          @change="temp_country = $event"
          :items="country_list"
          item-text="country"
          item-value="country"
          label="Ország"
          :rules="[rules.required]"
          outlined

        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_zip"
          @change="temp_zip = $event, getTempCityName($event)"
          v-mask="'####'"
          label="Irányítószám"
          :rules="[rules.required]"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          v-model="temp_city"
          :rules="[rules.required]"
          label="Város"
          outlined
          :loading = "temp_city_load"

        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_public_premises"
          @change="temp_public_premises = $event"
          label="Közterület"
          :rules="[rules.required]"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-autocomplete
          :value="temp_type_of_public_premises"
          @change="temp_type_of_public_premises = $event"
          :items="publicpermises"
          item-text="label"
          item-value="label"
          label="Közterület típusa"
          :rules="[rules.required]"
          outlined

        ></v-autocomplete>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="4">
        <v-text-field
          :value="temp_house_number"
          @change="temp_house_number = $event"
          label="Házszám"
          :rules="[rules.required]"
          outlined

        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_building_number"
          @change="temp_building_number = $event"
          label="Épület"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_stairway_number"
          @change="temp_stairway_number = $event"
          label="Lépcsőház"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_floor_number"
          @change="temp_floor_number = $event"
          label="Emelet"
          outlined

        ></v-text-field>
      </v-col>
      <v-col class="d-flex" cols="12" sm="6" md="3">
        <v-text-field
          :value="temp_door_number"
          @change="temp_door_number = $event"
          label="Ajtó"
          outlined

        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
          <v-checkbox
            v-model="billing_address"
            label="Eltérő számlázási adatok"
          ></v-checkbox>
      </v-col>
    </v-row>

    <div class="billing_address" v-if="billing_address">
      <div class="subtitle-1"><b>Számlázási adatok</b></div>
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            :value="bill_name"
            @change="bill_name = $event"
            label="Név"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :value="taxcode"
            @change="taxcode = $event"
            label="Adószám"
            outlined
            :rules="tax_code_rules"
            :disabled="taxCodeDisabled || no_company"
            v-mask="'########-#-##'"
            masked="false"
          >
        </v-text-field>
        <v-checkbox
        v-model="no_company"
        label="Magánszemély"
        dense
        ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-select
            :value="bill_country"
            @change="bill_country = $event"
            :items="country_list"
            item-text="country"
            item-value="country"
            label="Ország"
            :rules="[rules.required]"
            outlined

          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_zip"
            @change="bill_zip = $event, getBillCityName($event)"
            v-mask="'####'"
            label="Irányítószám"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            v-model="bill_city"
            :rules="[rules.required]"
            label="Város"
            outlined
            :loading = "bill_city_load"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_public_premises"
            @change="bill_public_premises = $event"
            label="Közterület"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-autocomplete
            :value="bill_type_of_public_premises"
            @change="bill_type_of_public_premises = $event"
            :items="publicpermises"
            item-text="label"
            item-value="label"
            label="Közterület típusa"
            :rules="[rules.required]"
            outlined

          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="4">
          <v-text-field
            :value="bill_house_number"
            @change="bill_house_number = $event"
            label="Házszám"
            :rules="[rules.required]"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_building_number"
            @change="bill_building_number = $event"
            label="Épület"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_stairway_number"
            @change="bill_stairway_number = $event"
            label="Lépcsőház"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_floor_number"
            @change="bill_floor_number = $event"
            label="Emelet"
            outlined

          ></v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6" md="3">
          <v-text-field
            :value="bill_door_number"
            @change="bill_door_number = $event"
            label="Ajtó"
            outlined

          ></v-text-field>
        </v-col>
      </v-row>
    </div>

<v-row>
  <v-col md="6">
    <v-btn
      v-if="customer_id"
      :disabled="!studDetailsVaild"
      color="primary"
      class="mr-4"
      @click="validate()"
      rounded
    >
    Mentés
    <v-icon right dark>save</v-icon>
    </v-btn>
    <v-btn
      color="red"
      class="mr-4"
      @click="getStudentDetails()"
      rounded
      outlined
    >
    Mégsem
    </v-btn>
  </v-col>
  </v-row>

  </v-form>
  </v-container>

<v-snackbar v-model="create_student_snackbar" bottom :color="!student_save_success ? 'error' : ''">
  {{student_save_result}}
  <v-btn :color="!student_save_success ? '' : 'pink'" text @click="create_student_snackbar = false">
    Bezár
  </v-btn>
</v-snackbar>

<v-dialog v-model="save_student_dialog" persistent max-width="290">
  <v-card>
    <v-card-text class="pt-4">Biztosan menteni szeretne?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" outlined @click="save_student_dialog = false">Nem</v-btn>
      <v-btn color="green" outlined @click="saveStudent(), save_student_dialog = false">Igen</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  </div>
</template>

<script>

import {
  mapFields
} from 'vuex-map-fields'


export default {
  data () {
    return {
      studentdetails: '',
      title: '',
      last_name: '',
      first_name: '',
      middle_name: '',
      full_name: '',
      birth_last_name: '',
      birth_middle_name: '',
      birth_first_name: '',
      place_of_birth: '',
      birthdate: '',
      nationality: '',
      mother_last_name: '',
      mother_first_name: '',
      mother_middle_name: '',
      email1: ' ',
      phone1: '',
      per_country: '',
      per_zip: '',
      per_city: '',
      per_type_of_public_premises: '',
      per_public_premises: '',
      per_house_number: '',
      per_building_number: '',
      per_stairway_number: '',
      per_floor_number: '',
      per_door_number: '',
      temp_country: '',
      temp_zip: '',
      temp_city: '',
      temp_type_of_public_premises: '',
      temp_public_premises: '',
      temp_house_number: '',
      temp_building_number: '',
      temp_stairway_number: '',
      temp_floor_number: '',
      temp_door_number: '',
      identity_card_number: '',
      description: '',
      archvie_student_dialog: false,
      active_student_dialog: false,
      save_student_dialog: false,
      student_save_result: '',
      create_student_snackbar: false,
      student_delete_result: '',
      student_delete_snackbar: false,
      title_options: [
        { text: 'Dr.', value: 'Dr.'},
        { text: 'dr.', value: 'dr.'},
        { text: '', value: ''},
      ],
      gender_items: [
        { text: 'Férfi', value: "1"},
        { text: 'Nő', value: "2"},
      ],
      gender: '',
      education_items: [
        { text: 'Végzettség nélkül', value: "1"},
        { text: 'Általános iskolai végzettség', value: "2"},
        { text: 'Középfokú végzettség és gimnáziumi érettségi (gimnázium)', value: "3"},
        { text: 'Középfokú végzettség és középfokú szakképesítés (szakgimnázium, szakképző iskola, szakiskola)', value: "4"},
        { text: 'Középfokú végzettség és középfokú szakképzettség (technikum)', value: "5"},
        { text: 'Felsőfokú végzettségi szint és felsőfokú szakképzettség (felsőoktatási intézmény)', value: "6"},
        { text: 'Felsőoktatási szakképzés (felsőoktatási intézmény)', value: "7"},
      ],
      education: '',
      tax_code: null,
      publicpermises: [],
      per_city_load: false,
      temp_city_load: false,
      bill_city_load: false,
      country_list: [],
      nationality_list: [],
      rules: {
          required: value => !!value || 'Kötelező mező!',
          parent_required: value => !!value || '18 éves kor alatt szülői hozzájárulás szükséges, a képzési szerződés erre az e-mail címre is megküldésre kerül! Amennyiben nem tud megadni szülői e-mail címet, a beiratkozáshoz kérjük keressék fel személyesen bármelyik ügyfélszolgálatunkat!',
          email: value => {
            if(value != '') {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Hibás e-mail cím!'
            }
          },
          tax_code: value => (this.name == this.full_name || this.no_company == true || !!value) || 'Céges vevő esetén kötelező!',
        },
      birthdateRules: [
          v => !!v || 'Kötelező mező!',
          v => /(\d{4})-(\d{2})-(\d{2})/.test(v) || 'Hibás születési dátum!',
      ],
      taxcodeRules: [
          v => this.no_tax == true || /\d{10}/.test(v) || 'Hibás adóazonosító!',
          v => this.no_tax == true || !!v || 'Kötelező mező!',
      ],
      student_save_success: '',
      no_tax: false,
      okirat_types: [],
      okirat_type: '',
      country_of_birth: '',
      address_card_number: '',
      billing_address: false,
      bill_country: '',
      bill_zip: '',
      bill_city: '',
      bill_public_premises: '',
      bill_type_of_public_premises: '',
      bill_house_number: '',
      bill_building_number: '',
      bill_stairway_number: '',
      bill_floor_number: '',
      bill_door_number: '',
      bill_name: '',
      taxcode: '',
      tax_code_rules: [
        value => (this.bill_name == this.full_name || this.no_company == true || !!value) || 'Céges vevő esetén kötelező!',
        value => (this.bill_name == this.full_name || this.no_company == true || /\d\d\d\d\d\d\d\d-\d-\d\d/.test(value)) || 'Hibás adószám formátum!',
      ],
      no_company: false,
      parent_email: '',
      parent_phone: '',
      registration_date: '',
    }
  },
  methods: {
    getStudentDetails: async function() {
      this.studentdetails = null
      await this.gettoken()
      this.preloader = true
      this.$http.post('/adatok/diakok_adatok_220818', {
        token: this.token
      }).then((response) => {
        this.studentdetails = response.data;
        this.preloader = false
        this.title = response.data[0]['title']
        this.archived = response.data[0]['archived']
        this.last_name = response.data[0]['last_name']
        this.first_name = response.data[0]['first_name']
        this.middle_name = response.data[0]['middle_name']
        this.full_name = response.data[0]['full_name']
        this.customer_name = response.data[0]['full_name']
        this.birth_last_name = response.data[0]['birth_last_name']
        this.birth_first_name = response.data[0]['birth_first_name']
        this.birth_middle_name = response.data[0]['birth_middle_name']
        this.place_of_birth = response.data[0]['place_of_birth']
        if (response.data[0]['country_of_birth'] == null || response.data[0]['country_of_birth'] == '') {
          this.country_of_birth = 'Magyarország';
        } else {
          this.country_of_birth = response.data[0]['country_of_birth']
        }
        this.birthdate = response.data[0]['birthdate']
        this.nationality = response.data[0]['nationality']
        this.gender = response.data[0]['gender']
        //this.tax_code = response.data[0]['tax_number']
        //this.no_tax = response.data[0]['no_tax']
        this.education = response.data[0]['qualification']
        this.mother_last_name = response.data[0]['mother_last_name']
        this.mother_first_name = response.data[0]['mother_first_name']
        this.mother_middle_name = response.data[0]['mother_middle_name']
        this.email1 = response.data[0]['email1']
        this.phone1 = response.data[0]['phone1']
        this.identity_card_number = response.data[0]['identity_card_number']
        this.okirat_type = response.data[0]['identity_card_type']
        this.description = response.data[0]['description']
        this.per_country = response.data[0]['per_country']
        this.per_zip = response.data[0]['per_zip']
        this.per_city = response.data[0]['per_city']
        this.per_type_of_public_premises = response.data[0]['per_type_of_public_premises']
        this.per_public_premises = response.data[0]['per_public_premises']
        this.per_house_number = response.data[0]['per_house_number']
        this.per_building_number = response.data[0]['per_building_number']
        this.per_stairway_number = response.data[0]['per_stairway_number']
        this.per_floor_number = response.data[0]['per_floor_number']
        this.per_door_number = response.data[0]['per_door_number']
        this.temp_country = response.data[0]['temp_country']
        this.temp_zip = response.data[0]['temp_zip']
        this.temp_city = response.data[0]['temp_city']
        this.temp_type_of_public_premises = response.data[0]['temp_type_of_public_premises']
        this.temp_public_premises = response.data[0]['temp_public_premises']
        this.temp_house_number = response.data[0]['temp_house_number']
        this.temp_building_number = response.data[0]['temp_building_number']
        this.temp_stairway_number = response.data[0]['temp_stairway_number']
        this.temp_floor_number = response.data[0]['temp_floor_number']
        this.temp_door_number = response.data[0]['temp_door_number']
        this.bill_country = response.data[0]['bill_country']
        this.bill_zip = response.data[0]['bill_zip']
        this.bill_city = response.data[0]['bill_city']
        this.bill_type_of_public_premises = response.data[0]['bill_type_of_public_premises']
        this.bill_public_premises = response.data[0]['bill_public_premises']
        this.bill_house_number = response.data[0]['bill_house_number']
        this.bill_building_number = response.data[0]['bill_building_number']
        this.bill_stairway_number = response.data[0]['bill_stairway_number']
        this.bill_floor_number = response.data[0]['bill_floor_number']
        this.bill_door_number = response.data[0]['bill_door_number']
        this.bill_name = response.data[0]['billing_name']
        this.taxcode = response.data[0]['taxcode']
        this.okirat_type =  response.data[0]['identity_card_type']
        this.address_card_number =  response.data[0]['address_card_number']
        this.registration_date = response.data[0]['registration_date']
        this.parent_email = response.data[0]['parent_email']
        this.parent_phone = response.data[0]['parent_phone']
        if (this.bill_name) {
          this.billing_address = true
        } else {
          this.billing_address = false
        }

      }, (error) => {
        this.error_text = error.data
      })
    },
    saveStudent: async function() {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/adatok/save_student_220915', {
        token: this.token,
        title: this.title,
        last_name: this.last_name,
        first_name: this.first_name,
        middle_name: this.middle_name,
        birth_last_name: this.birth_last_name,
        birth_first_name: this.birth_first_name,
        birth_middle_name: this.birth_middle_name,
        place_of_birth: this.place_of_birth,
        country_of_birth: this.country_of_birth,
        birthdate: this.birthdate,
        nationality: this.nationality,
        gender: this.gender,
        tax_number: this.tax_code,
        no_tax: this.no_tax,
        qualification: this.education,
        mother_last_name: this.mother_last_name,
        mother_first_name: this.mother_first_name,
        mother_middle_name: this.mother_middle_name,
        email1: this.email1,
        phone1: this.phone1,
        per_country: this.per_country,
        per_zip: this.per_zip,
        per_city: this.per_city,
        per_type_of_public_premises: this.per_type_of_public_premises,
        per_public_premises: this.per_public_premises,
        per_house_number: this.per_house_number,
        per_building_number: this.per_building_number,
        per_stairway_number: this.per_stairway_number,
        per_floor_number: this.per_floor_number,
        per_door_number: this.per_door_number,
        temp_country: this.temp_country,
        temp_zip: this.temp_zip,
        temp_city: this.temp_city,
        temp_type_of_public_premises: this.temp_type_of_public_premises,
        temp_public_premises: this.temp_public_premises,
        temp_house_number: this.temp_house_number,
        temp_building_number: this.temp_building_number,
        temp_stairway_number: this.temp_stairway_number,
        temp_floor_number: this.temp_floor_number,
        temp_door_number: this.temp_door_number,
        identity_card_number: this.identity_card_number,
        description: this.description,
        okirat_type: this.okirat_type,
        address_card_number: this.address_card_number,
        bill_country: this.bill_country,
        bill_zip: this.bill_zip,
        bill_city: this.bill_city,
        bill_public_premises: this.bill_public_premises,
        bill_type_of_public_premises: this.bill_type_of_public_premises,
        bill_house_number: this.bill_house_number,
        bill_building_number: this.bill_building_number,
        bill_stairway_number: this.bill_stairway_number,
        bill_floor_number: this.bill_floor_number,
        bill_door_number: this.bill_door_number,
        bill_name: this.bill_name,
        billing_address: this.billing_address,
        taxcode: this.taxcode,
        parent_email: this.parent_email,
        parent_phone: this.parent_phone
      }).then((response) => {
        this.preloader = false
        this.student_save_result = response.data['message']
        this.student_save_success = response.data['success']
        this.create_student_snackbar = true
        if (response.data['success']) {
          this.customer_id = response.data['id']
          this.getStudentDetails()
        } else {
          this.scrollToTop()
        }
      }, (error) => {
        this.student_save_result = error.data
        console.log(error.data);
      })
    },
    getPubpermises: async function() {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/adatok/pubpermises', {
        token: this.token,
      }).then((response) => {
        this.preloader = false
        this.publicpermises = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    getPerCityName: async function(irsz) {
      this.per_city_load = true
      await this.gettoken()
      this.$http.post('/adatok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.per_city_load = false
        this.per_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getTempCityName: async function(irsz) {
      this.temp_city_load = true
      await this.gettoken()
      this.$http.post('/adatok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.temp_city_load = false
        this.temp_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getBillCityName: async function(irsz) {
      this.bill_city_load = true
      await this.gettoken()
      this.$http.post('/adatok/irsz_list', {
        token: this.token,
        irsz: irsz
      }).then((response) => {
        this.bill_city_load = false
        this.bill_city = response.data[0]['place']
      }, (error) => {
        console.log(error.data);
      })
    },
    getCountryList: async function() {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/adatok/country_list', {
        token: this.token,
      }).then((response) => {
        this.preloader = false
        this.country_list = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    nationalityList: async function() {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/adatok/nationality_list', {
        token: this.token,
      }).then((response) => {
        this.preloader = false
        this.nationality_list = response.data
        //
      }, (error) => {
        console.log(error.data);
      })
    },
    OkiratType: async function() {
      this.preloader = true
      this.$http.get('/wsdl/OkiratType').then((response) => {
        this.preloader = false
        this.okirat_types = response.data
      }, (error) => {
        console.log(error.data);
      })
    },
    validate () {
      if (this.$refs.diak_adat_form.validate()) {
        this.save_student_dialog = true
      } else {
        this.scrollToTop()
      }
      },
    taxCheck () {
      this.$refs.diak_adat_form.validate()
    },
    reset () {
      this.$refs.diak_adat_form.reset()
    },
    resetValidation () {
      this.$refs.diak_adat_form.resetValidation()
    },
    scrollToTop() {
     window.scrollTo(0,0);
   },
    copyBirthName() {
      this.birth_last_name = this.last_name
      this.birth_first_name = this.first_name
      this.birth_middle_name = this.middle_name
    },
    copyAddress() {
      this.temp_country = this.per_country
      this.temp_zip = this.per_zip
      this.temp_city = this.per_city
      this.temp_type_of_public_premises = this.per_type_of_public_premises
      this.temp_public_premises = this.per_public_premises
      this.temp_house_number = this.per_house_number
      this.temp_building_number = this.per_building_number
      this.temp_stairway_number = this.per_stairway_number
      this.temp_floor_number = this.per_floor_number
      this.temp_door_number = this.per_door_number
    },
  },
  mounted() {
    this.getPubpermises();
    this.getCountryList();
    this.nationalityList();
    this.getStudentDetails()
    this.OkiratType()
  },
  updated() {

  },
  watch: {
    customer_id: function(value) {
      if (value) {
        this.getPubpermises();
        this.getCountryList();
        this.nationalityList();
        this.getStudentDetails()
      }
    },
    studentdetails: function (value) {
      if (value) {
        if (!value[0]['last_name'] && !value[0]['first_name']) {
          this.resetValidation()
        }
      }
    },
    no_tax(value) {
      if (value == true) {
        this.tax_code = null
      }
      this.$refs.diak_adat_form.validate()
    },
    no_company(value) {
      this.taxCheck()
      if (value) {
        this.taxcode = null
        this.taxCodeDisabled = true
      }
    },
  },
  computed: {
    ...mapFields([
      'actions.preloader',
      'ids.customer_id',
      'ids.contract_id',
      'ids.customer_name',
      'user_datas.studDetailsVaild'
    ]),
    taxCodeDisabled() {
      if (this.bill_name == this.full_name && this.full_name != "") {
        return true;
      } else {
        return false;
      }
    },
    check18() {
      let registration_date;
      if (this.registration_date == '' || this.registration_date == null) {
        registration_date = new Date().toISOString().substr(0, 10);
      } else {
        registration_date = this.registration_date.substr(0, 10);
      }
      var date1 = new Date(registration_date);
      var date2 = new Date(this.birthdate);
      var dateMinus18 = date1.setFullYear(date1.getFullYear() - 18);
      if (date2 <= dateMinus18) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="scss">
</style>
